import {
  Box,
  ButtonBase,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from "@mui/material";
import MoedaText from "../../../util/ui/inputs/moedaText";
import { IconFileInvoice, IconLock } from "@tabler/icons-react";
import { Skeleton } from "@mui/material";
import Darf from "../../../../models/darf";
import { useAssinar } from "../../assinatura/assine";
import FelixCard from "../../../util/ui/felixCard";
import AssinanteSwitch from "../../../util/ui/switch/assinanteSwitch";

type Props = {
  darf?: Darf;
};

export default function CardImposto({ darf }: Props) {
  const assinar = useAssinar();

  return (
    <FelixCard>
      <CardHeader title="Imposto" avatar={<IconFileInvoice size={16} />} />
      <CardContent>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignItems="flex-start"
        >
          <Typography
            color="text.primary"
            sx={{
              fontVariantNumeric: "tabular-nums",
              fontWeight: 600,
              fontSize: 28,
              letterSpacing: "-0.02em",
              paddingBottom: 2,
            }}
          >
            <AssinanteSwitch
              renderAssinante={() => {
                if (darf) return <MoedaText value={darf.impostoDevido} />;
                else
                  return (
                    <Skeleton variant="text" width={40} animation={false} />
                  );
              }}
              renderNaoAssinante={() => (
                <ButtonBase
                  sx={(theme) => ({
                    ...theme.typography.dataMono,
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                    fontSize: 28,
                    letterSpacing: "-0.02em",
                    gap: 0.5,
                  })}
                  disableRipple
                  onClick={() => assinar()}
                >
                  R$ **,**
                  <IconLock strokeWidth={2} size={24} />
                </ButtonBase>
              )}
            />
          </Typography>
        </Box>
        <Box display="flex" alignItems="flex-end">
          <Box
            display="flex"
            flexShrink={1}
            width="100%"
            flexDirection="column"
            alignItems="center"
          >
            <Typography
              variant="dataMono"
              color="text.primary"
              sx={{ fontWeight: 500 }}
            >
              <AssinanteSwitch
                renderAssinante={() => {
                  if (darf)
                    return (
                      <MoedaText value={darf.operacoesComuns.impostoDevido} />
                    );
                  else
                    return (
                      <Skeleton variant="text" width={40} animation={false} />
                    );
                }}
                renderNaoAssinante={() => <>R$ **,**</>}
              />
            </Typography>
            <Typography variant="labelMono" color="text.secondary" mt={0.5}>
              Comuns
            </Typography>
          </Box>
          <Divider
            sx={{ m: 1 }}
            orientation="vertical"
            variant="middle"
            flexItem
          />
          <Box
            display="flex"
            flexShrink={1}
            width="100%"
            flexDirection="column"
            alignItems="center"
          >
            <Typography
              variant="dataMono"
              color="text.primary"
              sx={{ fontWeight: 500 }}
            >
              <AssinanteSwitch
                renderAssinante={() => {
                  if (darf)
                    return (
                      <MoedaText value={darf.operacoesDaytrade.impostoDevido} />
                    );
                  else
                    return (
                      <Skeleton variant="text" width={40} animation={false} />
                    );
                }}
                renderNaoAssinante={() => <>R$ **,**</>}
              />
            </Typography>
            <Typography variant="labelMono" color="text.secondary" mt={0.5}>
              Daytrade
            </Typography>
          </Box>
          <Divider
            sx={{ m: 1 }}
            orientation="vertical"
            variant="middle"
            flexItem
          />
          <Box
            display="flex"
            flexShrink={1}
            width="100%"
            flexDirection="column"
            alignItems="center"
          >
            <Typography
              variant="dataMono"
              color="text.primary"
              sx={{ fontWeight: 500 }}
            >
              <AssinanteSwitch
                renderAssinante={() => {
                  if (darf)
                    return (
                      <MoedaText value={darf.operacoesFii.impostoDevido} />
                    );
                  else
                    return (
                      <Skeleton variant="text" width={40} animation={false} />
                    );
                }}
                renderNaoAssinante={() => <>R$ **,**</>}
              />
            </Typography>
            <Typography variant="labelMono" color="text.secondary" mt={0.5}>
              FII/Fiagro
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </FelixCard>
  );
}
